import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

import {
    Layout,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    DatePicker,
    Col,
    Table,
    Divider,
    Button,
    Modal,
    Popconfirm,
    Spin
} from "antd";
import { apiConfig, labelConfig, staticConfig } from "../../../../../group.config";
import { BOM } from '../../../../../../../services/definedMethod';


const { Text } = Typography

const DisbursementData = (props) => {

    const { disbursementTableSource, handleSave, setDisbursementValue, setDisbursementTableSource } = props;


    useEffect(() => {
        handleDisbursementPayloadData()
    }, []);

    const defaultDisbursementColumns = [
        {
            title: "Expected Disbursement Date",
            dataIndex: "expectedDisbursementDate",
        },
        {
            title: "Principal",
            dataIndex: "principal",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                disbursementTableSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDisbursementDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: "#15CCAE",
                                color: "white",
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <CloseOutlined
                            style={{
                                color: "#92428B",
                                fontSize: "15px",
                                fontWeight: "bolder",
                            }}
                        />
                    </Popconfirm>
                ) : null,
        },
    ];

    const disbursementColumns = defaultDisbursementColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                // handleSave,
            }),
        };
    });


    const handleDisbursementPayloadData = () => {

        let disbursementPayLoadData = [];

        disbursementTableSource.forEach((element) => {
            disbursementPayLoadData.push({
                id: element.id,
                expectedDisbursementDate: element.expectedDisbursementDate,
                principal: element.principal
            });
        });

        setDisbursementValue(disbursementPayLoadData);
    }

        
    const handleDisbursementDelete = (key) => {
        const newData = disbursementTableSource.filter((item) => item.key !== key);
        setDisbursementTableSource(newData);
    };

    return (

        <>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.maximumAllowedOutstanding}
                    name="maxOutstandingLoanBalance"
                >
                    <Input

                        placeholder={BOM.handlePlaceholderMsg(labelConfig.maximumAllowedOutstanding)}
                        style={{ font: "bolder" }}
                    />
                </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>

                <Form.Item
                // label={labelConfig.maximumAllowedOutstanding}
                >
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{
                            backgroundColor: "#15CCAE",
                            color: "white",
                            width: "15vh",
                            marginTop: 30,
                        }}
                        shape='round'
                    >
                        Add
                    </Button>
                </Form.Item>
            </Col>

            <Col span={24} style={{ padding: "0px 8px" }}>
                <Table
                    columns={disbursementColumns}
                    dataSource={disbursementTableSource}
                >
                </Table>
            </Col>
        </>
    )
}

export default DisbursementData